module.exports = __webpack_public_path__ + "img/f-grow-tree-green.bd2f22c6.svg";